import {AfterViewChecked, Component, OnInit} from '@angular/core';
import * as selectorsApp from '../../../../store/app/app.selectors';
import {selectAppViewPort} from '../../../../store/app/app.selectors';
import {Store} from '@ngrx/store';
import {State} from '../../../../store';
import * as appActions from '../../../../store/app/app.actions';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-thank-you-page',
  templateUrl: './thank-you-page.component.html',
  styleUrls: ['./thank-you-page.component.scss'],
})
export class ThankYouPageComponent implements OnInit, AfterViewChecked {

  platformBrandLogo = '';
  platformLandingPage = '';
  viewport = '';
  platformName = '';

  private subscriptions = [];

  constructor(
      public store: Store<State>,
  ) {}

  ngOnInit() {
    this.store.dispatch(appActions.getPublicUserGroup({typeUserGroup: 'platform_id',  queryValue: environment.platform_id }));
    this.store.select(selectAppViewPort).subscribe(result => {
      this.viewport = result;
    });
  }

  ngAfterViewChecked() {
    this.subscriptions.push(
        this.store.select(selectorsApp.selectUserGroup).subscribe(userGroup => {
          if (userGroup !== null ) {
            this.platformBrandLogo = userGroup.logo_login_url;
            this.platformName = userGroup.platform_name;
            this.platformLandingPage = userGroup.landing_page;
          }
        })
    );
  }
}
